import connector from 'Utils/connector';
import Newsletters from '../views/newsletters';
import {
  usageTrackNewsletterEnter,
  usageTrackNewsletterSubmitClick,
  usageTrackNewsletterSubmit,
} from '../redux/actions/usage-actions';

import { frictionlessSignup } from '../redux/actions/auth-actions';

export default connector({
  actions: {
    frictionlessSignup,
    usageTrackNewsletterEnter,
    usageTrackNewsletterSubmitClick,
    usageTrackNewsletterSubmit,
  },
})(Newsletters);
